import * as DialogPrimitive from '@radix-ui/react-dialog';


const Dialog = DialogPrimitive.Root;

export { Dialog };
